// Alert component
export default function () {
    let root;

    return {
        type: '',
        icon: '',
        heading: '',
        message: '',
        dismissible: '',

        get dismissed() {
            return root.hidden;
        },

        set dismissed(value) {
            root.hidden = value;
        },

        init() {
            root = this.$root;

            Object.assign(this, Helper.parseElementDataset(root));
            ['heading', 'message'].forEach((key) => (this[key] = root.querySelector(`.alert-${key}`).innerHTML));

            this.$watch(
                'type',
                (value) => (root.className = root.className.replace(/alert-(primary|secondary|success|danger|warning|info|light|dark)/g, 'alert-' + value))
            );

            this.$watch('message', (value) => {
                this.message = value.replace(/<a [^>]+>/g, (value) => {
                    if (value.includes('alert-link')) return value;

                    if (value.includes('class="')) {
                        return value.replace('class="', 'class="alert-link');
                    }

                    return value.replace('<a ', '<a class="alert-link" ');
                });
            });

            this.$watch('dismissible', (value) => root.classList[value ? 'add' : 'remove']('alert-dismissible'));
        },
    };
}
